
import props from './props'
export default {
  props,
  data() {
    return {
      selected: this.defaultValue || '',
    }
  },
}
